// extracted by mini-css-extract-plugin
module.exports = {"callout":"Callout_callout__1irPr","info":"Callout_info__2OZdq","icon":"Callout_icon__PcDGG"};